import { useEffect, useState } from "react";

const pcBreakpoint = 1024;

const useIsPc = () => {
  const [isPC, setIsPC] = useState(window.innerWidth > pcBreakpoint);
  const handleResize = () => {
    setIsPC(window.innerWidth > pcBreakpoint);
  };

  window.addEventListener("resize", handleResize);

  useEffect(() => {
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isPC;
};

export default useIsPc;
